import * as React from 'react';

export const PageLayoutContext = React.createContext({ offsetTop: 0 });

export const PageLayout = ({ offsetTop, children }) => (
  <PageLayoutContext.Provider value={{ offsetTop }}>
    {children}
  </PageLayoutContext.Provider>
);
